import type { TypeActiveFilter } from '@/context'
import { sanitizeFilters } from '../base'
import { URL_CUSTOM_EXCLUSION_PARAMS } from './exclusionParams'

/**
 * Converts search params (e.g. from URL) to active filters shape.
 * Sync, so it can be used in client-side popstate handler.
 */
export const searchParamsToActiveFilters = (searchParams: Record<string, string[]>): TypeActiveFilter[] => {
  const sanitizedSearchParams = sanitizeFilters(searchParams || {}, URL_CUSTOM_EXCLUSION_PARAMS)
  const keynamesArr = Object.keys(sanitizedSearchParams || {})
  if (!keynamesArr.length) return []

  return keynamesArr
    .map((keyname) => {
      const value = sanitizedSearchParams[keyname]
      if (!value) return null

      return {
        param: keyname,
        value: Array.isArray(value)
          ? value.map((val) => ({ name: '', slug: val }))
          : { name: '', slug: value },
      }
    })
    .filter(Boolean) as TypeActiveFilter[]
}

type TypeGetInitialActiveFilters = (searchParams: Record<string, string[]>) => Promise<TypeActiveFilter[]>
export const getInitialActiveFilters: TypeGetInitialActiveFilters = async (searchParams) =>
  Promise.resolve(searchParamsToActiveFilters(searchParams))
